import type { LandingPageTextSize } from "@forento/core/models/landing"

export const landingPageTextSizeClasses: Record<LandingPageTextSize, string> = {
	small: "text-sm leading-7 [&>h1]:text-2xl [&>h2]:text-xl [&>h3]:text-lg",
	medium: "text-base leading-8 [&>h1]:text-3xl [&>h2]:text-2xl [&>h3]:text-xl",
	large: "text-lg leading-8 [&>h1]:text-4xl [&>h2]:text-3xl [&>h3]:text-2xl",
	"extra-large": "text-xl leading-9 [&>h1]:text-5xl [&>h2]:text-4xl [&>h3]:text-3xl",
}
